import { TypeIconName } from '@bitrise/bitkit';
import { TypeAttribute, TypeAttributeSort } from '@trace/types';

export const ATTRIBUTE_FILTER_DEFAULT: TypeAttribute = 'app.version';
export const ATTRIBUTE_SORT_DEFAULT: TypeAttributeSort = 'metric:asc';

export const ATTRIBUTE_FILTER_ORDER: TypeAttribute[] = [
  'app.version',
  'device.country',
  'os.version',
  'device.type',
  'device.network',
  'device.carrier',
];

export const ATTRIBUTE_ICON_MAP: { [key in TypeAttribute]?: TypeIconName } = {
  'app.version': 'App',
  'device.country': 'Flag',
  'device.network': 'Globe',
  'device.type': 'Mobile',
  'device.carrier': 'Request',
  'os.version': 'Numero',
  duration: 'Stopwatch',
  timestamp: 'Calendar',
};

export const ATTRIBUTE_NAME_MAP: { [key in TypeAttribute]?: string } = {
  'app.version': 'App Version',
  'device.country': 'Country',
  'device.network': 'Network',
  'device.type': 'Device',
  'device.carrier': 'Carrier',
  'os.version': 'OS Version',
  duration: 'Duration',
  timestamp: 'Timestamp',
};

export const ATTRIBUTE_SESSION_ORDER: TypeAttribute[] = [
  'timestamp',
  'duration',
  'app.version',
  'device.type',
  'os.version',
  'device.country',
  'device.network',
  'device.carrier',
];

export const ATTRIBUTES_CRASH_ORDER: TypeAttribute[] = [
  'app.version',
  'device.type',
  'os.version',
  'device.country',
  'device.network',
  'device.carrier',
];

export const ATTRIBUTE_SORT_ORDER: TypeAttributeSort[] = [
  'metric:asc',
  'metric:desc',
  'samples:desc',
];
